import { createContext, FC, PropsWithChildren, useMemo, useState } from 'react';
import { SlideImage } from 'yet-another-react-lightbox';
import { ChatSourceViewerContextValues } from '@app/types/chat/source-viewer.ts';

const ChatSourceViewerContext =
  createContext<ChatSourceViewerContextValues | null>(null);

const ChatSourceViewerProvider: FC<PropsWithChildren> = ({ children }) => {
  const [isChatSourceViewerOpened, setIsChatSourceViewerOpened] =
    useState<boolean>(false);
  const [selectedImages, setSelectedImages] = useState<SlideImage[]>([]);
  const contextValue = useMemo(
    () => ({
      isChatSourceViewerOpened,
      selectedImages,
      setIsChatSourceViewerOpened,
      setSelectedImages,
    }),
    [
      isChatSourceViewerOpened,
      setIsChatSourceViewerOpened,
      selectedImages,
      setSelectedImages,
    ]
  );

  return (
    <ChatSourceViewerContext.Provider value={contextValue}>
      {children}
    </ChatSourceViewerContext.Provider>
  );
};

export { ChatSourceViewerContext, ChatSourceViewerProvider };
